import { ComponentType, FC, ReactNode } from 'react';

import { Token, TokenType } from './lib/lexer';
import { Amount, Hashtag, Mention, NewLine, TextString, UserTag } from './token-components';

export type DecorateSegment = (segment: ReactNode, type: TokenType) => ReactNode;

interface Props {
	decorateSegment?: DecorateSegment;
	token: Token;
}

type TokenSegmentProps = {
	text: string;
};

const TokenMap: Partial<Record<TokenType, ComponentType<TokenSegmentProps>>> = {
	[TokenType.AMOUNT]: ({ text }) => Amount(text),
	[TokenType.HASHTAG]: ({ text }) => Hashtag(text),
	[TokenType.MENTION]: ({ text }) => Mention(text),
	[TokenType.TEXT]: ({ text }) => TextString(text),
	[TokenType.USER_TAG]: ({ text }) => UserTag(text),
	[TokenType.NEWLINE]: NewLine,
};

const BonusTextSegment: FC<Props> = ({ decorateSegment, token: { kind, text } }) => {
	const Segment = TokenMap[kind];
	const result = Segment ? <Segment text={text} /> : null;
	return <>{decorateSegment?.(result, kind) || result}</>;
};

export default BonusTextSegment;
